import { __experimentalUnitControl as UnitControl } from "@wordpress/components";

export default function NumberUnit({ value, onChange, ...props }) {
    return (
        <UnitControl
            __next40pxDefaultSize
            onChange={onChange}
            value={value}
            {...props}
        />
    );
}
